module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAArElEQVRIx2NgaLMgHv0nBTCMGj24jHZM1Fyrwn+Lm+UdH98nd/dfe/ZQx+gCN9m3DAyvGRkqnaR/nznz59Klnxs2/Jg3j1KjrVO0gOY+ZWVySNKEB8jfN2/+ffr07/t3ioxepSYANHqxlhCE+2vz5r8fPnz29aVCgNzkYQUaHRGiDOH+mD37LTPzWxaW7xMm/H3/nlZG/6PQaBoGCA2jkYaJj7ZZZrR4GgJGAwCInkae3DZMUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/dz.png
// module id = 810
// module chunks = 0